import React from 'react';
import OverviewPage from './OverviewPage';
import LicenseTable from './LicenseTable';
import './OverviewPage.css';

const Dashboard: React.FC = () => {
  return (
    <div className="license-overview">
      <OverviewPage embedded />
      <LicenseTable />
    </div>
  );
};

export default Dashboard;
